import $ from 'jquery';
import $script from 'scriptjs';

import ShopifySectionsManager from 'shopify-sections-manager';
import PxsMap from '@pixelunion/pxs-map';
import rimg from '@pixelunion/rimg-shopify';
import VideoSection from '@pixelunion/pxs-video';
import { SiteAgeGate, PageAgeGate } from '@pixelunion/age-gate';

import './utils/jquery';
import './polyfills/nodeListForEach';

// Components
import BackToTop from './components/BackToTop';

// Templates
import TemplateAccountAddresses from './templates/TemplateAccountAddresses';
import TemplateAccountLogin from './templates/TemplateAccountLogin';
import TemplateGiftCard from './templates/TemplateGiftCard';
import TemplatePassword from './templates/TemplatePassword';

// Sections
import DynamicBlog from './sections/DynamicBlog';
import DynamicCollection from './sections/DynamicCollection';
import DynamicCountdownTimer from './sections/DynamicCountdownTimer';
import DynamicFaq from './sections/DynamicFaq';
import DynamicImageBlock from './sections/DynamicImageBlock';
import DynamicMenuList from './sections/DynamicMenuList';
import DynamicScrollingText from './sections/DynamicScrollingText';
import DynamicSlideshow from './sections/DynamicSlideshow';
import Static404 from './sections/Static404';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticCollectionList from './sections/StaticCollectionList';
import StaticFaq from './sections/StaticFaq';
import StaticHeader from './sections/StaticHeader';
import StaticPage from './sections/StaticPage';
import StaticPageContact from './sections/StaticPageContact';
import StaticProduct from './sections/StaticProduct';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import StaticSearch from './sections/StaticSearch';
import StaticSubcollection from './sections/StaticSubcollection';
import StaticFooter from './sections/StaticFooter';

const sectionMap = [
  { handle: 'dynamic-blog', SectionClass: DynamicBlog },
  { handle: 'dynamic-collection', SectionClass: DynamicCollection },
  { handle: 'dynamic-countdown-timer', SectionClass: DynamicCountdownTimer },
  { handle: 'dynamic-faq', SectionClass: DynamicFaq },
  { handle: 'dynamic-image-block', SectionClass: DynamicImageBlock },
  { handle: 'dynamic-menu-list', SectionClass: DynamicMenuList },
  { handle: 'dynamic-scrolling-text', SectionClass: DynamicScrollingText },
  { handle: 'dynamic-product', SectionClass: StaticProduct },
  { handle: 'dynamic-slideshow', SectionClass: DynamicSlideshow },
  { handle: 'pxs-video', SectionClass: VideoSection },
  { handle: 'static-404', SectionClass: Static404 },
  { handle: 'static-article', SectionClass: StaticArticle },
  { handle: 'static-blog', SectionClass: StaticBlog },
  { handle: 'static-cart', SectionClass: StaticCart },
  { handle: 'static-collection', SectionClass: StaticCollection },
  { handle: 'static-collection-list', SectionClass: StaticCollectionList },
  { handle: 'static-faq', SectionClass: StaticFaq },
  { handle: 'static-header', SectionClass: StaticHeader },
  { handle: 'static-page', SectionClass: StaticPage },
  { handle: 'static-page-contact', SectionClass: StaticPageContact },
  { handle: 'static-product', SectionClass: StaticProduct },
  { handle: 'static-product-recommendations', SectionClass: StaticProductRecommendations },
  { handle: 'static-search', SectionClass: StaticSearch },
  { handle: 'static-subcollection', SectionClass: StaticSubcollection },
  { handle: 'static-quickshop', SectionClass: StaticProduct },
  { handle: 'static-footer', SectionClass: StaticFooter },
  { handle: 'pxs-map', SectionClass: PxsMap },
  { handle: 'age-gate', SectionClass: PageAgeGate }
];

export default class Atlantic {
  constructor() {
    this.el = document.body;
    rimg.init();

    const sections = new ShopifySectionsManager();
    const $scripts = $('[data-scripts]');

    const prioritySections = document.querySelectorAll('[data-section-index="1"], [data-section-index="2"], [data-section-index="3"]');
    const priorityQueue = sectionMap.filter(({ handle }) => 
      [...prioritySections].some(el => el.dataset.sectionType === handle)
    );
    const secondaryQueue = sectionMap.filter(({ handle }) =>
      ![...prioritySections].some(el => el.dataset.sectionType === handle)
    );

    priorityQueue.forEach(({ handle, SectionClass}) => {
      sections.register(handle, section => new SectionClass(section));
    });

    secondaryQueue.forEach(({ handle, SectionClass }) => {
      sections.register(handle, section => new SectionClass(section));
    });

    if ($('body').hasClass('template-gift-card')) {
      this.templateGiftCard = new TemplateGiftCard({ el: this.el });
    }

    if ($('body').hasClass('template-customers-login')) {
      this.templateAccountLogin = new TemplateAccountLogin({ el: this.el });
    }

    if ($('body').hasClass('template-customers-addresses')) {
      $script(
        [
          $scripts.data('shopify-common'),
          $scripts.data('shopify-api-url'),
          $scripts.data('customer-area'),
        ],
        () => {
          $script($scripts.data('shopify-countries'), () => {
            this.templateAccountAddresses = new TemplateAccountAddresses({ el: this.el });
          });
      });
    }

    if ($('body').hasClass('template-password')) {
      this.templatePassword = new TemplatePassword({ el: this.el });
    }

    $('.field').on('focus', this.removeErrors.bind(this));

    const ageGatePage = document.getElementById('age-gate-page');

    if (ageGatePage) {
      new SiteAgeGate(ageGatePage);
    }

    const backToTop = document.querySelector('[data-back-to-top]');
    if (backToTop) new BackToTop(backToTop);
  }

  removeErrors(e) {
    const field = $(e.currentTarget, this.el);
    return field.removeClass('error');
  }
}

new Atlantic();
